/* eslint-disable import/prefer-default-export */
import {
  all, takeLatest, call, put,
} from 'redux-saga/effects';
import API, { responseParser } from '../../services/api';
import {
  FETCH_ZONES,
  SET_ZONES,
  FETCH_FIELDS,
  SET_FIELDS,
  SAVE_ZONE_UPDATE,
  UPDATE_ZONE,
  QUICK_RUN,
  MULTIPLE_QUICK_RUN,
  SET_ZONE_IMAGES,
} from './types';

function* getZones({ payload }) {
  const response = yield call(api.getZones, payload);
  const result = responseParser(response);
  if (result) {
    yield put({ type: SET_ZONES, payload: result });
  }
}

function* getZoneImages(payload) {
  const response = yield call(api.getZoneImages, payload);
  const result = responseParser(response);
  if (result) {
    yield put({ type: SET_ZONE_IMAGES, payload: result });
  }
}

function* getZoneFields() {
  const response = yield call(api.getZoneFields);
  const result = responseParser(response);
  if (result) {
    yield put({ type: SET_FIELDS, payload: result });
  }
}

function* saveZoneUpdate({ payload }) {
  const response = yield call(api.updateZone, payload);
  const result = responseParser(
    response,
    'Error while updating zone',
    null,
    true,
    true,
  );
  if (result) {
    yield put({ type: UPDATE_ZONE, payload: result });
  }
}

function* startQuickRun({ payload }) {
  const response = yield call(api.startQuickRun, payload);
  responseParser(response, 'Error', '', true, true);
}

function* startMultipleQuickRun({ payload }) {
  const response = yield call(api.startMultipleQuickRun, payload);
  responseParser(response, 'Error', '', true, true);
}

const api = API.create();
export function* combinedSagas() {
  yield all([
    yield takeLatest(FETCH_ZONES, getZones),
    yield takeLatest(FETCH_FIELDS, getZoneFields),
    yield takeLatest(SAVE_ZONE_UPDATE, saveZoneUpdate),
    yield takeLatest(QUICK_RUN, startQuickRun),
    yield takeLatest(MULTIPLE_QUICK_RUN, startMultipleQuickRun),
  ]);
}
